import {
  clearListFilters,
  readListFilters,
  writeListFilters,
} from "./listFilterStorage";
import { applicantSearchCompanyScope } from "./listFilterScopes";

const DEFAULT_MATCH_RATING = [1, 2, 3, 4, 5, "No Rating"];
const DEFAULT_REQUIRED_QUESTIONS = ["Passed", "Needs review", "NA"];

export function readApplicantSearchListState(companyId) {
  const scope = applicantSearchCompanyScope(companyId);
  const raw = scope ? readListFilters(scope) : null;
  if (!raw) return null;
  return normalizeApplicantSearchListState(raw);
}

export function writeApplicantSearchListState(companyId, payload) {
  const scope = applicantSearchCompanyScope(companyId);
  if (!scope || !payload) return;
  const { searchResults: _ignored, ...rest } = payload;
  writeListFilters(scope, rest);
}

export function clearApplicantSearchListState(companyId) {
  const scope = applicantSearchCompanyScope(companyId);
  if (scope) clearListFilters(scope);
}

export function normalizeApplicantSearchListState(raw) {
  return {
    query: typeof raw.query === "string" ? raw.query : "",
    matchRatingFilter: Array.isArray(raw.matchRatingFilter)
      ? raw.matchRatingFilter
      : DEFAULT_MATCH_RATING,
    requiredQuestionsFilter: Array.isArray(raw.requiredQuestionsFilter)
      ? raw.requiredQuestionsFilter
      : DEFAULT_REQUIRED_QUESTIONS,
    selectedApplicantIds: Array.isArray(raw.selectedApplicantIds)
      ? raw.selectedApplicantIds
      : [],
    currentPage:
      typeof raw.currentPage === "number" && raw.currentPage >= 1
        ? raw.currentPage
        : 1,
    sortField: typeof raw.sortField === "string" ? raw.sortField : null,
    sortDirection:
      raw.sortDirection === "asc" || raw.sortDirection === "desc"
        ? raw.sortDirection
        : null,
  };
}

export { DEFAULT_MATCH_RATING, DEFAULT_REQUIRED_QUESTIONS };
